export const snakificationCandidates = [
  {
    label: 'Webinar',
    detail: 'Turn one event into short evergreen chapters.',
    icon: 'video',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a36e44ce-198c-496c-99ba-dca9d9a2a434.jpg',
    alt: 'Illustration of a webinar becoming a series of short digital chapters',
  },
  {
    label: 'Website',
    detail: 'Add interaction to content already attracting visitors.',
    icon: 'monitor',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c06899d9-ee35-41d8-87ba-0c90a485e4b6.jpg',
    alt: 'Illustration of an interactive question embedded in a healthcare website',
  },
  {
    label: 'Campaign content',
    detail: 'Turn approved material into a short interactive campaign.',
    icon: 'megaphone',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/9f4feaba-d421-4b37-a3ba-e272b01cbfb6.jpg',
    alt: 'Illustration of source content branching into interactive campaign panels',
  },
  {
    label: 'Congress',
    detail: 'Create pre-, during- and post-event engagement.',
    icon: 'users',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/be087942-54d5-4162-a775-2583263669b1.jpg',
    alt: 'Illustration of connected digital engagement around a healthcare congress',
  },
  {
    label: 'Clinical / dosing content',
    detail: 'Make complex information easier to explore.',
    icon: 'flask',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e0be4232-38aa-4ccd-a28c-550a045b9afe.jpg',
    alt: 'Illustration of a guided clinical pathway with dosing steps',
  },
  {
    label: 'Patient content',
    detail: 'Adapt approved material into guided patient experiences.',
    icon: 'patient',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e0be4232-38aa-4ccd-a28c-550a045b9afe.jpg',
    alt: 'Illustration of a guided patient education pathway',
  },
] as const
